import ContentModerationIcon from './contentModeration.svg';
import CRMIcon from './CRM.svg';
import ReportingIcon from './reporting.svg';
import UsersManagementIcon from './usersManagement.svg';

export { ContentModerationIcon, CRMIcon, ReportingIcon, UsersManagementIcon };
